import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

// Simple confirm button:
// - Renders a single Semantic UI Button
// - On click, shows a native confirm dialog; only if user agrees we call onClick
// This avoids any DOM swapping that could confuse React/Semantic UI and cause
// "removeChild" errors when rows are removed.
const ConfirmButton = ({basic, icon, children, onClick, ...props}) => (
    <Button
        {...props}
        basic={basic}
        icon={icon}
        onClick={e => {
            if (!onClick) return;
            const ok = window.confirm("Willst du das wirklich löschen?");
            if (ok) {
                onClick(e);
            }
        }}
    >
        {children}
    </Button>
);

export default ConfirmButton;